import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";

import {
  createCountry,
  fetchCountries,
} from "../../store/slices/locationSlice";

const CountryCreatePopup = ({ show, onHide, onSuccess }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    code: "",
    phoneCode: "",
    isActive: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.code || !formData.phoneCode) {
      return;
    }

    try {
      setLoading(true);

      await dispatch(
        createCountry({
          name: formData.name,
          code: formData.code,
          phoneCode: formData.phoneCode,
          isActive: formData.isActive,
        }),
      ).unwrap();

      // REFRESH LIST
      const refreshed = await dispatch(fetchCountries()).unwrap();

      // FIND NEW COUNTRY
      const latestCountry = refreshed?.find((x) => x.name === formData.name);

      if (latestCountry && onSuccess) {
        onSuccess(latestCountry);
      }

      setFormData({
        name: "",
        code: "",
        phoneCode: "",
        isActive: true,
      });

      onHide();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Country</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="form_group mb-3">
          <label>Country Name</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter country name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        <div className="form_group mb-3">
          <label>Country Code</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter country code"
            name="code"
            value={formData.code}
            onChange={handleChange}
          />
        </div>

        <div className="form_group mb-3">
          <label>Phone Code</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter phone code"
            name="phoneCode"
            value={formData.phoneCode}
            onChange={handleChange}
          />
        </div>

        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="isActive"
            checked={formData.isActive}
            name="isActive"
            onChange={handleChange}
          />

          <label className="form-check-label" htmlFor="isActive">
            Active
          </label>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn_secondary" onClick={onHide}>
          Cancel
        </button>

        <button
          className="btn_primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CountryCreatePopup;
